import { ComponentType, useRef } from 'react';

export type LockHandlerProps<
  T extends object,
  K extends keyof Util.PickByType<Required<T>, Function>,
> = {
  Component: ComponentType<T>;
  handlerKey: K;
} & Record<K, (...p: any[]) => Promise<any>> &
  Omit<T, K>;

function LockHandler<T extends object, K extends keyof Util.PickByType<Required<T>, Function>>(
  props: LockHandlerProps<T, K>,
) {
  const { Component, handlerKey, [handlerKey]: handler, ...otherProps } = props;

  const loadingRef = useRef(false);

  const componentProps = {
    ...otherProps,
    [handlerKey]: (...p: any[]) => {
      if (loadingRef.current) {
        return;
      }

      loadingRef.current = true;

      handler(...p).finally(() => {
        loadingRef.current = false;
      });
    },
  } as T;

  return <Component {...componentProps} />;
}

export default LockHandler;
